var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-row",
    [
      _c(
        "b-col",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c("header-programa", {
                    attrs: { programa: _vm.solicitud?.programa },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.esReadOnly
            ? _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { staticClass: "mt-2 text-left" },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.abrirModal()
                            },
                          },
                        },
                        [
                          _c("b-icon-search"),
                          _vm._v(" "),
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t(
                                  "apeironGwApp.actividadesRetribucion.acciones.buscarBecario"
                                )
                              ),
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-overlay",
            { attrs: { show: _vm.consultandoElBack } },
            [
              _c(
                "b-row",
                { staticClass: "mt-3" },
                [
                  _c(
                    "b-col",
                    {
                      attrs: {
                        "align-v": "end",
                        offset: "0",
                        "offset-lg": "6",
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: {
                          placeholder: _vm.$t(
                            "apeironGwApp.actividadesRetribucion.acciones.buscar"
                          ),
                        },
                        on: {
                          keyup: function ($event) {
                            return _vm.buscarEnTablaBecarios()
                          },
                          keydown: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            $event.preventDefault()
                          },
                        },
                        model: {
                          value: _vm.filtroBecariosTabla,
                          callback: function ($$v) {
                            _vm.filtroBecariosTabla = $$v
                          },
                          expression: "filtroBecariosTabla",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mt-2" },
                [
                  _c(
                    "b-col",
                    { staticClass: "area-responsive area-responsive-tabla" },
                    [
                      _c("b-table", {
                        attrs: {
                          id: "my-table",
                          striped: "",
                          hover: "",
                          bordered: "",
                          small: "",
                          "thead-class": "custom-header",
                          items: _vm.becariosTablaFiltrados,
                          fields: _vm.fieldsBecariosTabla,
                          "show-empty": "",
                          "empty-text": _vm.$t(
                            "apeironGwApp.actividadesRetribucion.mensajes.sinRegistros"
                          ),
                          "per-page": _vm.perPageBecariosTabla,
                          "current-page": _vm.currentPageBecariosTabla,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "cell(becario)",
                            fn: function (data) {
                              return [
                                _c("span", {
                                  domProps: {
                                    textContent: _vm._s(
                                      data.item.becario?.nombre
                                    ),
                                  },
                                }),
                                _vm._v(" "),
                                _c("span"),
                                _vm._v(" "),
                                _c("span", {
                                  domProps: {
                                    textContent: _vm._s(
                                      data.item.becario?.apellidoPaterno
                                    ),
                                  },
                                }),
                                _vm._v(" "),
                                _c("span"),
                                _vm._v(" "),
                                _c("span", {
                                  domProps: {
                                    textContent: _vm._s(
                                      data.item.becario?.apellidoMaterno
                                    ),
                                  },
                                }),
                              ]
                            },
                          },
                          {
                            key: "cell(responsable)",
                            fn: function (data) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "text-center" },
                                  [
                                    _c("b-form-checkbox", {
                                      attrs: {
                                        disabled: !_vm.esEscritura,
                                        switch: "",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.seleccionarResponsable(
                                            data.item
                                          )
                                        },
                                      },
                                      model: {
                                        value: data.item.responsable,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            data.item,
                                            "responsable",
                                            $$v
                                          )
                                        },
                                        expression: "data.item.responsable",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "cell(acciones)",
                            fn: function (data) {
                              return [
                                _c(
                                  "b-button",
                                  {
                                    attrs: {
                                      size: "sm",
                                      variant: "danger",
                                      disabled: _vm.esReadOnly,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.eliminarBecario(data.item)
                                      },
                                    },
                                  },
                                  [
                                    _c("span", {
                                      domProps: {
                                        textContent: _vm._s(
                                          _vm.$t(
                                            "apeironGwApp.actividadesRetribucion.acciones.eliminar"
                                          )
                                        ),
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mt-4" },
                [
                  _c(
                    "b-col",
                    { attrs: { md: "4" } },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { md: "4" } },
                            [
                              _c("b-form-select", {
                                attrs: {
                                  size: "sm",
                                  id: "per-page-select",
                                  options: _vm.pageOptions,
                                },
                                on: { change: _vm.buscarEnTablaBecarios },
                                model: {
                                  value: _vm.perPageBecariosTabla,
                                  callback: function ($$v) {
                                    _vm.perPageBecariosTabla = $$v
                                  },
                                  expression: "perPageBecariosTabla",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              staticClass: "pie-tabla mt-1",
                              attrs: { md: "8" },
                            },
                            [
                              _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t(
                                      "apeironGwApp.actividadesRetribucion.mensajes.registrosPorPagina"
                                    )
                                  ),
                                },
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { md: "4" } },
                    [
                      _c("b-pagination", {
                        attrs: {
                          "total-rows": _vm.totalBecariosTabla,
                          "per-page": _vm.perPageBecariosTabla,
                          "aria-controls": "my-table",
                        },
                        model: {
                          value: _vm.currentPageBecariosTabla,
                          callback: function ($$v) {
                            _vm.currentPageBecariosTabla = $$v
                          },
                          expression: "currentPageBecariosTabla",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    {
                      staticClass: "text-right pie-tabla mt-1",
                      attrs: { md: "4" },
                    },
                    [
                      _c("span", {
                        domProps: {
                          textContent: _vm._s(_vm.totalBecariosTabla),
                        },
                      }),
                      _vm._v(" "),
                      _c("span", {
                        staticClass: "ml-1",
                        domProps: {
                          textContent: _vm._s(
                            _vm.$t(
                              "apeironGwApp.actividadesRetribucion.mensajes.totalDeRegistros"
                            )
                          ),
                        },
                      }),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-modal",
                        {
                          attrs: { name: "modal-agregar-becarios", size: "xl" },
                          on: {
                            hide: function ($event) {
                              return _vm.cerrarModal()
                            },
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "modal-title",
                              fn: function () {
                                return [
                                  _c("span", {
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.$t(
                                          "apeironGwApp.actividadesRetribucion.modalBusquedaBecarios.titulo"
                                        )
                                      ),
                                    },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "modal-footer",
                              fn: function () {
                                return [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "mt-3",
                                      attrs: { variant: "secondary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.cerrarModal()
                                        },
                                      },
                                    },
                                    [
                                      _c("span", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "apeironGwApp.actividadesRetribucion.acciones.cerrar"
                                            )
                                          ),
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                          model: {
                            value: _vm.mostrarModalAgregar,
                            callback: function ($$v) {
                              _vm.mostrarModalAgregar = $$v
                            },
                            expression: "mostrarModalAgregar",
                          },
                        },
                        [
                          _vm._v(" "),
                          _c("buscador-becario", {
                            attrs: {
                              tipoSolucion: "BECAS_NACIONALES",
                              clavePrograma: _vm.solicitud.programa?.clave,
                            },
                            on: {
                              selected: function ($event) {
                                return _vm.manejaBecariosSeleccionados($event)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c("b-col", [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary btn-lg btn-block",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.guardarBecarios()
                          },
                        },
                      },
                      [
                        _c("span", {
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t(
                                "apeironGwApp.actividadesRetribucion.acciones.guardarSeccion"
                              )
                            ),
                          },
                        }),
                      ]
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }